import { t } from "../../../i18n";
import { Button, Dialog } from "../../ui";
import type { Expense } from "../types";

interface DeleteExpenseDialogProps {
  expense: Expense;
  onClose: () => void;
  onConfirm: (expense: Expense) => void;
}

export function DeleteExpenseDialog({ expense, onClose, onConfirm }: DeleteExpenseDialogProps) {
  return (
    <Dialog
      open
      onClose={onClose}
      size="sm"
      title={t.settlement.expenses.deleteDialog.title}
      description={t.settlement.expenses.deleteDialog.description(expense.description)}
      footer={
        <>
          <Button onClick={onClose}>{t.common.cancel}</Button>
          <Button variant="danger" iconLeft="trash" onClick={() => onConfirm(expense)}>
            {t.settlement.expenses.deleteDialog.submit}
          </Button>
        </>
      }
    />
  );
}
